import React, { useLayoutEffect, useRef, useState } from 'react';
import T from 'prop-types';

import SharesChart from './SharesChart';
import ShareHeatmap from './ShareHeatmap';
import ChartTypeToggle from '../../ChartTypeToggle';
import { MarketShareDropdown, marketShareMetrics } from '../../MetricLists';

const emptyObject = {};

const MarketShareChart = ({ apps, series, isPending, isPress }) => {
  const contentRef = useRef(null);

  const [selectedMetric, setSelectedMetric] = useState(Object.keys(marketShareMetrics)[0]);
  const [chartType, setChartType] = useState('column');
  const [contentHeight, setContentHeight] = useState(364); // To be able to animate content height change

  const isCumulative = selectedMetric.includes('cumulative');
  const isPopChange = selectedMetric.includes('pop');

  const showChartTypeToggle = !isCumulative && !isPopChange;

  const metricSeries = series?.[selectedMetric] || emptyObject;

  useLayoutEffect(() => {
    if (contentRef.current) {
      setContentHeight(contentRef.current.scrollHeight);
    }
  }, [isCumulative, isPopChange]);

  return (
    <div className="market-share-chart">
      <header className="market-share-chart__header">
        <MarketShareDropdown selected={selectedMetric} onChange={setSelectedMetric} />
        {showChartTypeToggle && (
          <ChartTypeToggle active={chartType} disabled={isPending} onChange={setChartType} />
        )}
      </header>
      <div className="market-share-chart__content" style={{ height: contentHeight }}>
        <div ref={contentRef} className="market-share-chart__content-inner">
          {isPopChange ? (
            <ShareHeatmap metricSeries={metricSeries} apps={apps} isPending={isPending} />
          ) : (
            <SharesChart
              key={isCumulative ? 'cumulative-share' : 'market-share'} // force remount on type change to animate switch
              metricSeries={metricSeries}
              chartType={chartType}
              apps={apps}
              isPending={isPending}
              isCumulative={isCumulative}
              isPress={isPress}
            />
          )}
        </div>
      </div>
    </div>
  );
};

MarketShareChart.propTypes = {
  series: T.object,
  apps: T.array,
  isPending: T.bool.isRequired,
  isPress: T.bool,
};

export default MarketShareChart;
